import { IconClose, IconPdf, Dropzone } from '@ui/src';
import { DocumentCreateTypes } from './types';

import cn from './info.module.css';

const DocumentCreate = ({
  onUpload,
  dropZoneInputRef,
  onDelete,
  uploadInputRef,
  fileUploadInProgress,
  uploadedFiles,
  uploadedFilesErrors,
}: DocumentCreateTypes) => (
  <div className={cn.documentCreate}>
    <div className={cn.fileInputWrapper}>
      <div className={cn.inputTitle}>File</div>
      <label htmlFor="upload-input" className={cn.fileInputLabel}>
        <input
          type="file"
          id="upload-file"
          className={cn.fileInput}
          onChange={(e) => onUpload(e.target.files as FileList)}
          ref={uploadInputRef}
          multiple
        />
        <div className={cn.fileInputVisual}>Select document on your PC</div>
      </label>
    </div>
    <Dropzone
      onUpload={onUpload}
      fileUploadInProgress={fileUploadInProgress}
      inputRef={dropZoneInputRef}
      dropzoneText="or drop file here"
      dropzoneClassName={cn.documentDropZone}
      dropzoneTextClassName={cn.documentDropZoneText}
    />
    {uploadedFiles &&
      uploadedFiles.length > 0 &&
      uploadedFiles.map((item) => (
        <div className={cn.uploadedDocument} key={item.id}>
          <IconPdf />
          {item.name}
          <button
            type="button"
            className={cn.removeDocumentButton}
            onClick={() => onDelete(item.id)}
            aria-label="Close"
          >
            <IconClose />
          </button>
        </div>
      ))}
    {uploadedFilesErrors && uploadedFilesErrors.length > 0 && (
      <ul className={cn.uploadedFilesErrors}>
        {uploadedFilesErrors.map((item) => (
          <li key={item}>{`- ${item}`}</li>
        ))}
      </ul>
    )}
  </div>
);

export default DocumentCreate;
